define('modules/pages/customers/detail/body/catalog/tools/view',[
  'app',
  'module',
  'backbone',
  'underscore',
  'jquery',
  'settings',
  'tableFieldView',
  'buttonView',
  'productSelectDialogView',
  'bootbox'
], function (
  App,
  Module,
  Backbone,
  _,
  $,
  Settings,
  FieldView,
  ButtonView,
  ProductSelectDialog,
  bootbox
) {
  'use strict';

  function i18nOr(defKey, fallback) {
    try { return _.i18n(defKey) || fallback; } catch (e) { return fallback; }
  }

  // Resolve product code from selection item. Returns a jQuery Promise resolving to the code string.
  function resolveProductCode(item) {
      try {
        var productModel = App.request && App.request('products:model', { secId: item.rowid });
        if (productModel && productModel.fetch) {
          var d = $.Deferred();
          productModel.fetch().done(function () {
              d.resolve(productModel.get('cCode'));
          }).fail(function () {
            // Fallback to rowid if fetch fails
            d.resolve(item.rowid);
          });
          return d.promise();
        }
      } catch (e) {
        // noop, fallback below
      }
      return $.Deferred().resolve(item.rowid).promise();
  }

  Module.exports = FieldView.extend({
    // Inline template returning 3 button regions
    template: function () {
      return '' +
        '<div class="catalog-tools-view" style="width:100%">' +
          '<div class="btns" style="display:flex; align-items:center; justify-content:flex-end; gap:6px; width:100%">' +
            '<div class="edit-button-region"></div>' +
            '<div class="generate-button-region"></div>' +
            '<div class="delete-button-region"></div>' +
          '</div>' +
        '</div>';
    },
    className: 'customers-detail-body-catalogs-tools-view ' + FieldView.prototype.className,

    regions: {
      editButtonRegion: '.edit-button-region',
      generateButtonRegion: '.generate-button-region',
      deleteButtonRegion: '.delete-button-region'
    },

    onRender: function () {
      // Edit button
      this.editButtonView = new ButtonView({
        type: 'edit',
        color: 'lightgrey',
        title: i18nOr('common.edit', 'Edit'),
        text: i18nOr('common.edit', 'Edit')
      });
      this.getRegion('editButtonRegion').show(this.editButtonView);
      this.editButtonView.on('click', _.bind(this.onEdit, this));

      // Generate button
      this.generateButtonView = new ButtonView({
        type: 'reload',
        color: 'green',
        title: i18nOr('catalogs.generate', 'Generate'),
        text: i18nOr('catalogs.generate', 'Generate')
      });
      this.getRegion('generateButtonRegion').show(this.generateButtonView);
      this.generateButtonView.on('click', _.bind(this.onGenerate, this));

      // Delete button
      this.deleteButtonView = new ButtonView({
        type: 'remove',
        color: 'red',
        title: i18nOr('common.delete', 'Delete'),
        text: i18nOr('common.delete', 'Delete')
      });
      this.getRegion('deleteButtonRegion').show(this.deleteButtonView);
      this.deleteButtonView.on('click', _.bind(this.onDelete, this));
    },

    // -------- Actions --------
    onGenerate: function () {
      var model = this.model;
      var tableView = this.tableView;
      var btn = this.generateButtonView;
      try { if (btn.setDisabled) { btn.setDisabled(true); } } catch (e) {}
      var url = Settings.url('compuzz2', 'v2/catalog/instances/' + encodeURIComponent(model.get('secId')) + '/generate');
      $.ajax({ type: 'POST', url: url })
        .done(function () {
          try { if (App.alertSuccess) { App.alertSuccess(i18nOr('catalogs.generated', 'Catalog generation started')); } } catch (e) {}
          // After generation request, refresh ONLY this row to reflect status/fileUid changes
          try {
            if (tableView.refreshRow) {
              tableView.refreshRow(model.get('secId'));
            } else if (tableView.refresh) {
              tableView.refresh();
            }
          } catch (e) {}
          // Start polling the table every 5s until generation completes or fails
          try {
            if (tableView.startGenerationPolling) {
              tableView.startGenerationPolling(model.get('secId'), { intervalMs: 5000 });
            }
          } catch (e) {}
        })
        .fail(function (xhr) {
          var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || i18nOr('common.error', 'Error');
          try { if (App.alertError) { App.alertError(msg); } } catch (e) { bootbox.alert(msg); }
        })
        .always(function () {
          try { if (btn.setDisabled) { btn.setDisabled(false); } } catch (e) {}
        });
    },

    onDelete: function () {
      var model = this.model;
      var tableView = this.tableView;
      bootbox.confirm(i18nOr('common.confirmDelete', 'Are you sure?'), function (result) {
        if (!result) return;
        var url = Settings.url('compuzz2', 'v2/catalog/instances/' + encodeURIComponent(model.get('secId')));
        $.ajax({ type: 'DELETE', url: url })
          .done(function () {
            try { if (App.alertSuccess) { App.alertSuccess(i18nOr('catalogs.deleted', 'Catalog deleted')); } } catch (e) {}
            tableView.refresh();
          })
          .fail(function (xhr) {
            var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || i18nOr('common.error', 'Error');
            try { if (App.alertError) { App.alertError(msg); } } catch (e) { bootbox.alert(msg); }
          });
      });
    },

    onEdit: function () {
      var that = this;
      var instance = this.model.toJSON();
      var endUserSecId = instance.endUserSecId;

      // Build dialog content (avoid multiline string escapes for JSHint)
      var html = [
        '<div class="catalog-edit-dialog">',
        '  <div class="form-group">',
        '    <label>', i18nOr('catalogs.definition', 'Catalog definition'), '</label>',
        '    <select class="form-control js-definition"></select>',
        '  </div>',
        '  <div class="form-group">',
        '    <div class="clearfix" style="margin-bottom:6px;">',
        '      <label style="margin:0;">', i18nOr('menu.products', 'Products'), '</label>',
        '      <button type="button" class="btn btn-xs btn-default pull-right js-add-products">', i18nOr('catalogs.addProducts', 'Add products'), '</button>',
        '    </div>',
        '    <ul class="js-products sortable"></ul>',
        '    <div class="help-block">', i18nOr('common.dragToReorder', 'Drag to reorder'), '</div>',
        '  </div>',
        '</div>'
      ].join('');
      var $content = $(html);

      bootbox.dialog({
        title: i18nOr('common.edit', 'Edit catalog'),
        message: $content,
        className: 'catalog-edit-popup',
        buttons: {
          cancel: { label: i18nOr('common.cancel', 'Cancel'), className: 'btn-default' },
          save: {
            label: i18nOr('common.save', 'Save'), className: 'btn-primary', callback: function () {
              var defSecId = $content.find('.js-definition').val();
              var newProducts = [];
              $content.find('.js-products > li').each(function (idx, li) {
                var code = $(li).attr('data-code');
                if (code) newProducts.push({ productCode: code, displayOrder: idx });
              });
              var payload = {
                secId: instance.secId,
                endUserSecId: endUserSecId,
                productCatalogDefinition: { secId: defSecId },
                products: newProducts
              };
              var url = Settings.url('compuzz2', 'v2/catalog/instances/' + encodeURIComponent(instance.secId));
              return $.ajax({
                type: 'PUT',
                url: url,
                contentType: 'application/json',
                data: JSON.stringify(payload)
              }).done(function () {
                try { if (App.alertSuccess) { App.alertSuccess(i18nOr('catalogs.updated', 'Catalog updated')); } } catch (e) {}
                that.tableView.refresh();
              }).fail(function (xhr) {
                var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || i18nOr('common.error', 'Error');
                try { if (App.alertError) { App.alertError(msg); } } catch (e) { bootbox.alert(msg); }
                return false; // keep dialog open
              });
            }
          }
        }
      });

      // Populate definitions
      var defUrl = Settings.url('compuzz2', 'v2/catalog/definitions');
      $.get(defUrl).done(function (defs) {
        var $sel = $content.find('.js-definition');
        var currentDefSecId = (instance.productCatalogDefinition && instance.productCatalogDefinition.secId) || '';
        _.each(defs || [], function (d) {
          var name = (d.name && (d.name.values && (d.name.values[Settings.get('lang')] || d.name.values.en || d.name.values.fr))) ||
                     (d.name && (d.name[Settings.get('lang')] || d.name.en || d.name.fr)) ||
                     '';
          var $opt = $('<option></option>').attr('value', d.secId).text(name || d.secId);
          if (d.secId === currentDefSecId) $opt.attr('selected', 'selected');
          $sel.append($opt);
        });
      });

      // Populate products
      var $list = $content.find('.js-products');
      var products = instance.products || [];
      _.chain(products)
        .sortBy(function (p) { return p.displayOrder || 0; })
        .each(function (p) {
          var text = p.productCode;
          // Build list item with a dedicated drag handle for sortable
          var $li = $('<li class="sortable-item" style="display:flex; align-items:center; padding:4px 0;"></li>').attr('data-code', p.productCode);
          var $handle = $('<span class="drag-handle" style="cursor:move; margin-right:6px;">⋮⋮</span>');
          var $label = $('<span class="item-label" style="flex:1; min-width:0;"></span>').text(text);
          var $removeRegion = $('<span class="remove-button-region" style="margin-left:6px;"></span>');
          // Use ButtonView to match Product Catalog remove buttons
          try {
            var removeBtn = new ButtonView({
              type: 'remove',
              color: 'red',
              text: i18nOr('common.remove', 'Remove'),
              title: i18nOr('common.remove', 'Remove')
            });
            removeBtn.render();
            $removeRegion.append(removeBtn.$el);
            removeBtn.on('click', function () { $li.remove(); });
          } catch (e) {
            // Fallback clickable text if ButtonView fails
            var $fallback = $('<span class="text-danger" style="cursor:pointer;">' + i18nOr('common.remove', 'Remove') + '</span>');
            $fallback.on('click', function(){ $li.remove(); });
            $removeRegion.append($fallback);
          }
          $li.append($handle).append($label).append($removeRegion);
          $list.append($li);
        });

      // Enable drag-and-drop (requires jQuery UI Sortable loaded globally in the app)
      try { $list.sortable({ items: '> li', handle: '.drag-handle', axis: 'y', tolerance: 'pointer' }); } catch (e) {}

      // In-dialog Add Products handler: open selector and merge into list (no immediate save)
      $content.find('.js-add-products').on('click', function () {
        var dlg = new ProductSelectDialog({ multiSelect: true, displayLeaveButton: false });
        dlg.listenTo(dlg, 'products-selected', function (selected) {
          // Collect existing codes in the list
          var existingCodes = [];
          $list.find('li').each(function () { var c = $(this).attr('data-code'); if (c) existingCodes.push(String(c)); });

          // For each selection, resolve its code (supports rowid-only case)
          var promises = _.map(selected || [], function (it) { return resolveProductCode(it); });

          $.when.apply($, promises).always(function () {
            var results = arguments;
            // If only one promise, jQuery passes the single value directly
            var codes = [];

            // For multiple promises, each result can be the resolved value or [value, status, xhr]
            for (var i = 0; i < results.length; i++) {
                var r = results[i];
                codes.push(_.isArray(r) ? r[0] : r);
            }

            _.each(codes, function (code) {
              code = code !== null ? String(code) : '';
              if (code && existingCodes.indexOf(code) === -1) {
                existingCodes.push(code);
                var $li = $('<li class="sortable-item" style="display:flex; align-items:center; padding:4px 0;"></li>').attr('data-code', code);
                var $handle = $('<span class="drag-handle" style="cursor:move; margin-right:6px;">⋮⋮</span>');
                var $label = $('<span class="item-label" style="flex:1; min-width:0;"></span>').text(code);
                var $removeRegion = $('<span class="remove-button-region" style="margin-left:6px;"></span>');
                try {
                  var removeBtn = new ButtonView({
                    type: 'remove',
                    color: 'red',
                    text: i18nOr('common.remove', 'Remove'),
                    title: i18nOr('common.remove', 'Remove')
                  });
                  removeBtn.render();
                  $removeRegion.append(removeBtn.$el);
                  removeBtn.on('click', function () { $li.remove(); });
                } catch (e) {
                  var $fallback = $('<span class="text-danger" style="cursor:pointer;">' + i18nOr('common.remove', 'Remove') + '</span>');
                  $fallback.on('click', function(){ $li.remove(); });
                  $removeRegion.append($fallback);
                }
                $li.append($handle).append($label).append($removeRegion);
                $list.append($li);
              }
            });

            try {
              if ($list.data('ui-sortable')) { $list.sortable('refresh'); }
              else { $list.sortable({ items: '> li', handle: '.drag-handle', axis: 'y', tolerance: 'pointer' }); }
            } catch (e) {}
            dlg.hide();
          });
        });
        dlg.show({ title: i18nOr('dialog.offer.selectProduct', 'Select products'), className: 'product-selection-dialog' });
      });
    }

    // (onAddProducts removed — this flow now lives inside the edit popup)
  });
});

